<template>
  <div ref="tabs" class="product-tabs" :class="{'product-tabs--top': isHiddenHeader}">
    <div class="page-container product-tabs__container">
      <div class="product-tabs__blur"></div>
      <div class="product-tabs__list-container">
        <ul class="product-tabs__list">
          <li class="product-tabs__item" :class="{ 'active': (activeTab === 'description' || activeTab === ' ' || !isInTabs), 'not-touch': !isTouch }" @click.prevent="setActiveTab($event, 'description')">
            <a class="product-tabs__pseudo-link" :href="href('description')">{{ $t('tab.description') }}</a>
          </li>
          <li
            v-if="characteristics && (characteristics.length >= 1 && Object.values(characteristics[0])[0].length)"
            class="product-tabs__item"
            :class="{ 'active': activeTab === 'characteristics', 'not-touch': !isTouch }"
            @click.prevent="setActiveTab($event, 'characteristics')">
            <a class="product-tabs__pseudo-link" :href="href('characteristics')">{{ $t('tab.characteristic') }}</a>
          </li>
          <li v-if="comments"
              class="product-tabs__item"
              :class="{ 'active': activeTab === 'comments', 'not-touch': !isTouch }"
              @click.prevent="setActiveTab($event, 'comments')">
            <a class="product-tabs__pseudo-link" :href="href('comments')">{{ $t('comment') }} {{ comments.total_count ? `(${comments.total_count})` : '' }}</a>
          </li>
          <li v-if="questions"
              class="product-tabs__item"
              :class="{ 'active': activeTab === 'questions', 'not-touch': !isTouch }"
              @click.prevent="setActiveTab($event, 'questions')">
            <a class="product-tabs__pseudo-link" :href="href('questions')">{{ $t('questions.tab_title') }} {{ questions.total_count ? `(${questions.total_count})` : '' }}</a>
          </li>
          <li
            v-if="videos && videos.length > 0"
            class="product-tabs__item"
            :class="{ 'active': activeTab === 'videos', 'not-touch': !isTouch }"
            @click.prevent="setActiveTab($event, 'videos')">
            <a class="product-tabs__pseudo-link" :href="href('videos')">{{ $t('tab.video') }} ({{ videos.length }})</a>
          </li>
          <li
            v-if="equipments && (equipments.length >= 1 && Object.values(equipments[0])[0].length)"
            class="product-tabs__item"
            :class="{ 'active': activeTab === 'equipment', 'not-touch': !isTouch }"
            @click.prevent="setActiveTab($event, 'equipment')">
            <a class="product-tabs__pseudo-link" :href="href('equipment')">{{ $t('tab.equipment') }}</a>
          </li>
          <li
            v-if="instructions && (instructions.length >= 1)"
            class="product-tabs__item"
            :class="{ 'active': activeTab === 'instructions', 'not-touch': !isTouch }"
            @click.prevent="setActiveTab($event, 'instructions')">
            <a class="product-tabs__pseudo-link" :href="href('instructions')">{{ $t('tab.instructions') }}</a>
          </li>
          <li
            v-if="combinedProducts"
            class="product-tabs__item"
            :class="{ 'active': activeTab === 'combined-products', 'not-touch': !isTouch }"
            @click.prevent="setActiveTab($event, 'combined-products')">
            <a class="product-tabs__pseudo-link" :href="href('combined-products')">{{ $t('combined_products_tab_title') }}</a>
          </li>
          <!--          <li class="product-tabs__item" :class="{ 'active': activeTab === 'exploitation' }">-->
          <!--            <span class="product-tabs__pseudo-link" @click="setActiveTab('exploitation')">-->
          <!--              Эксплуатация-->
          <!--            </span>-->
          <!--          </li>-->
        </ul>
      </div>
      <PriceWithButton v-if="(inStock || availableInStore) && (activeTab === 'description' || activeTab === ' ') && !isBtnBuyShow" product-tabs />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PriceWithButton from '../../../components/product/product-page/PriceWithButton'
import { isAdaptiveMode } from '../../../mixins'
import { isTouch } from '../../../mixins/isTouchDevice'
import router from '@/router'
import { GoogleTagManagerService } from '@/services/AnalyticService'

export default {
  name: 'ProductTabs',
  components: {
    PriceWithButton
  },
  mixins: [ isAdaptiveMode, isTouch ],
  data () {
    return {
      initialOffset: null,
      tab: new URL(window.location).searchParams.get('tab') ? new URL(window.location).searchParams.get('tab') : ' '
    }
  },
  computed: {
    ...mapState({
      tabs: state => state.productTabs.tabs,
      activeTab: state => state.productTabs.activeTab,
      isHiddenHeader: state => state.productTabs.isHiddenHeader,
      isBtnBuyShow: state => state.productTabs.isBtnBuyShow,
      inStock: state => state.productInfo.productInfo.inStock,
      videos: state => state.productInfo.productInfo.videos,
      comments: state => state.comments.comments,
      questions: state => state.questions.comments,
      characteristics: state => state.productInfo.productInfo.characteristics,
      equipments: state => state.productInfo.productInfo.equipments,
      instructions: state => state.productInfo.productInfo.instructions,
      combinedProducts: state => state.productInfo.productInfo.combinedProducts,
      availableInStore: state => state.productInfo.productInfo.availableInStore
    }),
    isInTabs () {
      return this.tabs.includes(this.activeTab)
    },
    tabFromRoute () {
      return router.app._route.query.tab
    }
  },
  methods: {
    href (tab) {
      return window.location.origin + window.location.pathname + '?tab=' + tab
    },
    ...mapActions(['SET_ACTIVE_TAB', 'SET_INITIAL_OFFSET']),
    setActiveTab (e, name) {
      if (e) {
        GoogleTagManagerService.btnClickAnalytics({
          event: `click_tab_${name}`
        })
        const { target } = e

        let elementScrollTo = target.tagName === 'A' ? target.parentElement : target
        elementScrollTo.scrollIntoView({ inline: 'start' })
      }

      const data = {
        string: name,
        top: this.isAdaptiveMode ? this.initialOffset - 40 : this.initialOffset
      }
      this.SET_ACTIVE_TAB(data)
    }
  },
  mounted () {
    // включаем активную табу при инициализации
    this.SET_ACTIVE_TAB({ string: this.tab, top: 0 })

    // высчитываем положение таб бара
    this.initialOffset = this.$refs.tabs.offsetTop + 1

    // повторно высчитываем положение таб бара (для корректного значения)
    this.$nextTick(() => {
      setTimeout(() => {
        this.initialOffset = this.$refs.tabs.offsetTop + 1
      }, 100)
    })
  },
  watch: {
    // записываем положение таб бара во vuex для использования в дочерних компонентах
    initialOffset (value) {
      this.SET_INITIAL_OFFSET(value)
    },
    tabFromRoute (value) {
      value ? this.setActiveTab(null, value) : this.setActiveTab(null, ' ')
    }
  }
}
</script>

<style scoped lang="sass">

.product-tabs
  position: sticky
  top: 48px
  width: 100%
  margin-top: 30px
  border-top: 1px solid $nd-border-color
  border-bottom: 1px solid $nd-border-color
  z-index: 3
  background-color: $white-text-color
  line-height: 1.2
  transition: top ease-in-out .3s
  outline: none

  +mmin($tablet--hor)
    top: 0

  &--top
    top: 0

.product-tabs__container
  position: relative
  overflow: hidden
  height: 40px
  padding: 0

  +mmin($tablet)
    height: 50px

.product-tabs__blur
  background: -webkit-linear-gradient(0deg,rgba(255, 255, 255, 0),rgba(255, 255, 255, 1))
  height: 100%
  position: absolute
  pointer-events: none
  right: 0
  top: 0
  width: 24px
  z-index: 2

  +mmin($tablet)
    display: none

.product-tabs__list-container
  overflow-x: scroll
  overflow-y: hidden
  padding: 0 15px 10px 0

  +mmin($tablet)
    padding-left: 0

.product-tabs__list
  +list-unstyled
  display: inline-block
  white-space: nowrap
  overflow: hidden

.product-tabs__item
  display: inline-block
  font-size: 14px
  color: $text-color
  padding: 0 10px

  +mmin($tablet)
    padding: 0 15px

  &:first-child
    padding-left: 15px

  &:last-child
    padding-right: 0

.product-tabs__item.not-touch .product-tabs__pseudo-link:hover
  border-bottom: 2px solid #ccc

.product-tabs__item.active .product-tabs__pseudo-link,
.product-tabs__item.active .product-tabs__pseudo-link:hover
  border-bottom: 2px solid $main-color

.product-tabs__pseudo-link
  display: block
  color: $text-color
  cursor: pointer
  width: 100%
  padding: 11px 0

  +mmin($tablet)
    padding: 16px 0

</style>
